<template>
  <generic-modal
    size
    :title="$t('customer account module configuration')"
    icon="settings"
    image="/images/icons/accounts.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
    @destroy="destroy"
  >
    <div class="description">
      <div class="ui form">
        <h4 class="ui dividing header">{{ $t("settings") }}</h4>
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("account") }}</label>
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="public"
                v-model="stp.register_account"
              />
              <label>{{
                $t("register an account on customer creation")
              }}</label>
            </div>
          </div>
          <div class="field" v-bind:class="{ disabled: !stp.register_account }">
            <label for>{{ $t("account type") }}</label>
            <div class="ui selection dropdown" ref="account_type_dropdown">
              <input type="hidden" name="ddwn" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
        </div>
      </div>
      <movement-types style="margin-top:20px" />
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import MovementTypes from "./MovementTypes";

export default {
  name: "CustomerAccountConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    MovementTypes,
  },
  computed: {},
  data() {
    return {
      setup: {},
      stp: {
        register_account: true,
        account_type: "",
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/customer_account/do-save-configuration", {
          s: vm.stp,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/customer_account/do-get-configuration")
      .then((conf) => {
        if (conf) {
          vm.stp = JSON.parse(conf.setup);
          setTimeout(() => {
            window
              .jQuery(vm.$refs.account_type_dropdown)
              .dropdown("set selected", vm.stp.account_type);
          }, 500);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    local_api(vm, "post", "/account_type/do-get-list", {})
      .then((accountTypes) => {
        let vls = accountTypes.map((t) => {
          return { name: t.name, value: t.type_id };
        });

        window
          .jQuery(vm.$refs.account_type_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.stp.account_type = value;
            },
          });
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    window.jQuery(".ui.menu .item").tab();
  },
  watch: {},
  updated: function() {},
};
</script>
